// src/components/dashboard/VideosWidget/VideosWidget.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { profileService } from '../../../services/profileService';
import './VideosWidget.css';

const VideosWidget = () => {
  const navigate = useNavigate();
  const [newVideosCount, setNewVideosCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewVideosCount();
  }, []);

  const fetchNewVideosCount = async () => {
    try {
      const data = await profileService.getNewVideosCount();
      setNewVideosCount(data.new_videos_count || 0);
    } catch (err) {
      console.error('Error fetching new videos count:', err);
      setNewVideosCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    navigate('/profile', { state: { activeTab: 'videos' } });
  };

  return (
    <div className="videos-widget-container">
      <button 
        className="videos-icon-button" 
        onClick={handleClick}
        title={newVideosCount > 0 ? `${newVideosCount} new video${newVideosCount > 1 ? 's' : ''}` : 'No new videos'}
      >
        {/* Video/Play Icon Symbol */}
        <div className="videos-symbol">
          <div className="play-triangle"></div>
        </div>
        
        {/* Red dot indicator when there are new videos */}
        {newVideosCount > 0 && (
          <span className="new-indicator"></span>
        )}
      </button>
      
      <span className="widget-label">Videos</span>
    </div>
  );
};

export default VideosWidget;